// This file only does only purpose: Custom CSS for Shopify Chat
document.addEventListener('DOMContentLoaded', function () {
  const cssRule = `
    button.chat-toggle {
    height: 40px;
    width: 40px;
    }
    button.chat-toggle.chat-toggle--icon-button.icon-only svg, 
    button.chat-toggle.chat-toggle--icon-button.mobile-only svg {
    height: 35px;
    }
    button.chat-toggle.chat-toggle--text-button {
    height: 50px;
    }
    .chat-app .chat-app--close-button {
    height: 45px;
    width: 45px;
    }
    button.chat-toggle svg { 
    height: 40px;
    }
    button.chat-toggle .chat-title {
    font-size: 20px;
    }
  `;
  // Function to inject CSS into the shadow DOM
  function injectCssIntoShadowDom(shadowRoot, observer) {
    const styleElement = document.createElement('style');
    styleElement.appendChild(document.createTextNode(cssRule));
    shadowRoot.appendChild(styleElement);

    // Disconnect the observer after the CSS has been injected
    observer.disconnect();
  }

  // Function to apply styles when shadow DOM is detected
  function applyStyles(observer) {
    const shadowHost = document.querySelector('#ShopifyChat');
    if (shadowHost?.shadowRoot) {
      injectCssIntoShadowDom(shadowHost.shadowRoot, observer);
    }
  }

  // Create a MutationObserver to watch for changes in the DOM
  const observer = new MutationObserver(function (mutations) {
    const shadowHost = document.querySelector('inbox-online-store-chat');
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes[0] === shadowHost) {
        applyStyles(observer);
      }
    });
  });

  // Start observing the document body for changes
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial check in case the shadow DOM is already present
  applyStyles(observer);
});
